import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../constants';

const CustomSelect = styled.select`
  -webkit-padding-end: 20px;
  -webkit-padding-start: 2px;
  -webkit-user-select: none;
  background-color: transparent;
  position: relative;
  z-index: 2;
  width: ${({width}) => width};
  border-color: ${COLORS.BACKGROUND_GRAY};
  padding-left: 15px;
  color: ${({color}) => color};
`;

const CustomIcon = styled(FontAwesomeIcon).attrs({
  className: 'fa-w-14',
})`
  &&& {
    position: ${({position}) => position};
    right: 10px;
    top: ${({position}) => position === 'absolute' ? '12px' : '0'}
    color: ${({color}) => color};
  }
`;

const RelativeDiv = styled.div`
  position: relative;
`;

class Select extends PureComponent {
  render() {
    const {children, width, customIconStyle, customSelectStyle, absolute, value, ...selectProps} = this.props;
    const color = value === 'default' ? COLORS.SELECT_GRAY : COLORS.SELECT_BLACK;
    return (
      <RelativeDiv>
        <CustomSelect width={width} style={customSelectStyle} color={color} value={value} {...selectProps}>
          {children}
        </CustomSelect>
        <CustomIcon className="custom-select-icon" icon={faChevronDown} style={customIconStyle} color={color} position={absolute ? 'absolute' : 'relative'} />
      </RelativeDiv>
    );
  }
}

Select.defaultProps = {
  width: '70px',
  position: false,
};

Select.propTypes = {
  children: PropTypes.any.isRequired,
  width: PropTypes.string,
  customIconStyle: PropTypes.object,
  customSelectStyle: PropTypes.object,
  absolute: PropTypes.bool,
};

export default Select;
